const PROPERTY_IMAGE_FALLBACKS = {
  apartment: '/rooms/apartment.jpg',
  dorm: '/rooms/dorm.jpg',
  dormitory: '/rooms/dorm.jpg',
  estate: '/rooms/estate.jpg',
  studio: '/rooms/studio.jpg',
  'village house': '/rooms/village-house.jpg'
};

export function getHouseImageFallback(propertyType) {
  const normalizedType = String(propertyType || '').trim().toLowerCase();
  return PROPERTY_IMAGE_FALLBACKS[normalizedType] || '/rooms/other.jpg';
}

export function useHouseImageFallback(event, propertyType) {
  const image = event && (event.currentTarget || event.target);
  if (!image) return;

  image.onerror = null;
  image.src = getHouseImageFallback(propertyType);
}
